import BackIcon from '@/icons/back-icon';
import { GapSdkContext } from '@/pages/(gapsdk)/_provider/gap-sdk-provider';
import { useContext } from 'react';

export default function CloseAppRoot() {
  const { event } = useContext(GapSdkContext);
  return (
    <div className="fixed left-0 top-0 z-[999] flex h-20 w-full items-center justify-between px-7 py-3 text-[2rem]">
      <BackIcon
        style={{ width: 60, height: 60 }}
        onClick={() => event.onCloseApp()}
      />
    </div>
  );
}
